"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports._sortChildren = void 0;

var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/sort"));

var React = _interopRequireWildcard(require("react"));

var _getResponsiveStep = require("../styling/getResponsiveStep");

var _getResponsiveStepValues = require("../styling/getResponsiveStepValues");

var _getResponsiveValue = require("../styling/getResponsiveValue");

var _ResponsiveGridMarkers = require("./ResponsiveGridMarkers");

var _sortChildren = function _sortChildren(children, responsiveMode, responsiveSteps) {
  var _context;

  return (0, _sort.default)(_context = React.Children.toArray(children)).call(_context, function (a, b) {
    return getOrder(a, responsiveMode, responsiveSteps) - getOrder(b, responsiveMode, responsiveSteps);
  });
};

exports._sortChildren = _sortChildren;

var getOrder = function getOrder(child, responsiveMode, responsiveSteps) {
  if (!_ResponsiveGridMarkers.ResponsiveGridCellMarker.isMarked(child)) {
    return 0;
  }

  var props = child.props;
  responsiveSteps = (0, _getResponsiveStepValues.getResponsiveStepValues)(props.responsiveSteps, responsiveSteps);
  var orders = (0, _getResponsiveStepValues.getResponsiveStepValues)(props.order, [0]);
  var step = (0, _getResponsiveStep.getResponsiveStep)(responsiveMode, responsiveSteps);
  return (0, _getResponsiveValue.getResponsiveValue)(orders, step, 0);
};